import { useEffect, useState, useRef } from "react";
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import { ddStyles } from "../utils/CommonStyles.js";
import FetchUtil from "../utils/FetchUtil";

let appSurveyOptions = [];
let supplierOptions = [];
function DelegateAppSurveyTableRow({ index, selectedDelegate, primaryBuyerCompanyId, secondaryBuyerCompanyId, delegateAppSurveyItem, handleSubmit, setError, t, setAdd, setEdit, edit, oddIdx }) {
    const navigate = useNavigate();
    const [supplierKey, setSupplierKey] = useState(selectedDelegate.companyId);
    const [delegateKey, setDelegateKey] = useState(selectedDelegate.delegateKey);
    const [isSubmit, setIsSubmit] = useState(false);
    const [appSurveyNames, setAppSurveyNames] = useState([]);
    const [appSurveyLoaded, setAppSurveyLoaded] = useState(false);
    const [appSurveySelected, setAppSurveySelected] = useState({ name: "appSurveyKey", label: delegateAppSurveyItem.surveyDisplayName, value: delegateAppSurveyItem.appSurveyKey });
    const canReadRef = useRef(null);
    const [isCanRead, setIsCanRead] = useState(delegateAppSurveyItem.canRead ? 1 : 0);
    const canWriteRef = useRef(null);
    const [isCanWrite, setIsCanWrite] = useState(delegateAppSurveyItem.canWrite ? 1 : 0);
    const canReviewRef = useRef(null);
    const [isCanReview, setIsCanReview] = useState(delegateAppSurveyItem.canReview ? 1 : 0);
    const onlyReadMediumHighScoreRef = useRef(null);
    const [isOnlyReadMediumHighScore, setIsOnlyReadMediumHighScore] = useState(delegateAppSurveyItem.onlyReadMediumHighScore ? 1 : 0);

    useEffect(() => {
        fetchAppSurveys(selectedDelegate.companyId, selectedDelegate.parentCompanyKey);
    }, []);

    const appSurveyHandler = (selectedOption, action) => {
        let appSurveyKey = selectedOption ? selectedOption.value : 0;
        let appSurveyLabel = selectedOption ? selectedOption.label : "";
        setAppSurveySelected({ ...appSurveySelected, label: (appSurveyLabel), value: appSurveyKey });
    }

    function fetchAppSurveys(selectedSupplierKey, parentCompanyKey) {
        setError("");
        let buyerCompanyId = (parentCompanyKey && parentCompanyKey != '0') ? parentCompanyKey : primaryBuyerCompanyId;
        if (!selectedSupplierKey || selectedSupplierKey === 0 || !buyerCompanyId) {
            return;
        }
        setAppSurveyNames([]);
        appSurveyOptions = [];
        setAppSurveySelected({ ...appSurveySelected, label: "", value: 0 });
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                source: "web", getAll: false,
                supplierKey: selectedSupplierKey,
                buyerKey: buyerCompanyId,
                includeInactivePartner: true
            }),
        };
        try {
            FetchUtil.fetchAPI("GetPartnerAppSurveys", "/Service/CompanyService/GetPartnerAppSurveys", requestOptions, retrieveAppSurveySuccess, retrieveAppSurveyFail);
        } catch (error) {
            throw new Error(error.message);
        }
    }

    function retrieveAppSurveyFail(redirect) {
        if (redirect) {
            navigate("/");
        }
        setError(t("error.getAppSurveyFailed"));
    }

    function retrieveAppSurveySuccess(responseData) {
        let getPartnerAppSurveyResponse;
        if (responseData) {
            getPartnerAppSurveyResponse = responseData.getPartnerAppSurveyResponse;
            if (getPartnerAppSurveyResponse && getPartnerAppSurveyResponse.errorCode === "0") {
                setAppSurveyValues(getPartnerAppSurveyResponse.appSurveyList);
                if (getPartnerAppSurveyResponse.appSurveyList) {
                    setAppSurveyNames(getPartnerAppSurveyResponse.appSurveyList.slice());
                }
            } else if (getPartnerAppSurveyResponse && getPartnerAppSurveyResponse.errorCode === "114") {
                navigate("/", {
                    state: {
                        errorMessage: t("error.sessionTimeout"),
                    },
                });
            } else if (getPartnerAppSurveyResponse) {
                setError(t("error.error") + " " + getPartnerAppSurveyResponse.errorMessage);
            } else {
                setError(t("error.system.fetch"));
            }
        }
    }

    function setAppSurveyValues(appSurveyObj) {
        let appSurveyValue = {};
        appSurveyOptions = [];
        let selectedAppSurveyName = "";
        let selectedAppSurveyKey = 0;
        if ((delegateAppSurveyItem && Object.keys(delegateAppSurveyItem).length > 0)) {
            selectedAppSurveyKey = delegateAppSurveyItem.appSurveyKey;
        }
        if (appSurveyObj && appSurveyObj.length > 0) {
            appSurveyObj.map((aAppSurvey, idx) => {
                if (aAppSurvey.supplierKey != secondaryBuyerCompanyId) {
                    appSurveyValue.label = aAppSurvey.surveyDisplayName;
                    appSurveyValue.value = aAppSurvey.appSurveyKey;
                    appSurveyOptions.push(appSurveyValue);
                    appSurveyValue = {};
                }
                if (aAppSurvey.appSurveyKey == selectedAppSurveyKey) {
                    selectedAppSurveyName = aAppSurvey.surveyDisplayName;
                }

            });
            setAppSurveyLoaded(true);
            if (selectedAppSurveyName) {
                setAppSurveySelected({ ...appSurveySelected, label: selectedAppSurveyName, value: selectedAppSurveyKey });
            } else {
                setAppSurveySelected({ ...appSurveySelected, label: "", value: 0 });
            }
        }
    }

    const onResponseChange = (event) => {
        //console.log(event.target + "  " + event.target.name + " " + event.target.checked);
        const { name, id } = event.target;
        //event.preventDefault();
        //event.stopPropagation();
        if (name.startsWith("canRead_")) {
            setIsCanRead(event.target.checked);
        } else if (name.startsWith("canWrite_")) {
            setIsCanWrite(event.target.checked);
        } else if (name.startsWith("canReview_")) {
            setIsCanReview(event.target.checked);
        } else if (name.startsWith("onlyReadMediumHighScore_")) {
            setIsOnlyReadMediumHighScore(event.target.checked);
        }

    }

    function submitComplete() {
        setIsSubmit(false);
    }

    function submitRow() {
        setError("");
        setIsSubmit(true);
        let action = 1;
        let surveyDelegateKey = 0;
        let editDelegateKey = delegateKey;
        let appSurveyKey = 0;
        if ((delegateAppSurveyItem && Object.keys(delegateAppSurveyItem).length > 0)) {
            action = 2;
            surveyDelegateKey = delegateAppSurveyItem.surveyDelegateKey;
            appSurveyKey = delegateAppSurveyItem.appSurveyKey;
            if (editDelegateKey == 0) {
                editDelegateKey = delegateAppSurveyItem.delegateKey;
            }
        } else {
            appSurveyKey = appSurveySelected.value;
        }
        if (!supplierKey || supplierKey === 0) {
            setError(t("error.supplier.Reqd"));
            setIsSubmit(false);
        } else if (!appSurveyKey || appSurveyKey === 0) {
            setError(t("error.appSurveyNameReqd"));
            setIsSubmit(false);
        } else {

            let initialValues = {
                surveyDelegateKey: surveyDelegateKey,
                companyKey: supplierKey,
                appSurveyKey: appSurveyKey,
                canRead: canReadRef.current.checked,
                canWrite: canWriteRef.current.checked,
                canReview: canReviewRef.current.checked,
                onlyReadMediumHighScore: onlyReadMediumHighScoreRef.current.checked,
                action: action,
                delegateKey: editDelegateKey,
            };
            handleSubmit(action, initialValues, submitComplete);
        }

    }
    function submitCancel() {
        setError("");
        setAdd(false);
        setEdit(false);
        setIsSubmit(false);
    }
    return (
        <tr key={index}>
            <td className={oddIdx ? "list-td col odd" : "list-td col even"}>
                {selectedDelegate ?
                    ((selectedDelegate.parentCompanyName && selectedDelegate.parentCompanyName != "") ?
                        selectedDelegate.parentCompanyName + " <- " : "") + selectedDelegate.companyName : delegateAppSurveyItem.companyName}
            </td>
            <td className={oddIdx ? "list-td col odd" : "list-td col even"}>
                {(!edit) ?
                    appSurveyLoaded ? <Select
                        name="appSurveyKey"
                        options={appSurveyOptions}
                        onChange={appSurveyHandler}
                        placeholder={""}
                        value={appSurveySelected}
                        isSearchable={true}
                        isClearable={true}
                        className="myselect"
                        inputId="appSurveyKey-input"
                        styles={ddStyles}
                    />
                        : <></> : delegateAppSurveyItem.surveyDisplayName}
            </td>
            <td className={oddIdx ? "list-td col odd" : "list-td col even"}>
                <input type="checkbox" className="mycheckbox"
                    ref={canReadRef}
                    name={"canRead_0"}
                    id={"canRead_0"}
                    defaultChecked={true}
                    checked={isCanRead}
                    onChange={onResponseChange}
                />
            </td>
            <td className={oddIdx ? "list-td col odd" : "list-td col even"}>
                <input type="checkbox" className="mycheckbox"
                    ref={canWriteRef}
                    name={"canWrite_0"}
                    id={"canWrite_0"}
                    defaultChecked={true}
                    checked={isCanWrite}
                    onChange={onResponseChange}
                />
            </td>
            <td className={oddIdx ? "list-td col odd" : "list-td col even"}>
                <input type="checkbox" className="mycheckbox"
                    ref={canReviewRef}
                    name={"canReview_0"}
                    id={"canReview_0"}
                    defaultChecked={true}
                    checked={isCanReview}
                    onChange={onResponseChange}
                />
            </td>
            <td className={oddIdx ? "list-td col odd" : "list-td col even"}>
                <input type="checkbox" className="mycheckbox"
                    ref={onlyReadMediumHighScoreRef}
                    name={"onlyReadMediumHighScore_0"}
                    id={"onlyReadMediumHighScore_0"}
                    defaultChecked={true}
                    checked={isOnlyReadMediumHighScore}
                    onChange={onResponseChange}
                />
            </td>
            <td className={oddIdx ? "list-td col odd" : "list-td col even"}>{t("page.active")}</td>
            <td className={oddIdx ? "list-td col odd" : "list-td col even"}>
                <div id="submit-spinner"
                    className={isSubmit ? "spinner-border spinner-border-sm text-dark spinner-size" : "spinner-hide"}
                >
                </div>
                <button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"} onClick={() => (submitRow())}>{t("page.submit")}</button>
                <button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"} onClick={() => (submitCancel())}>{t("page.cancel")}</button>
            </td>
        </tr>
    )

}
export default DelegateAppSurveyTableRow;